/**
 * Newsletter-specific type mappings for audit logs.
 *
 * These mappings translate raw backend newsletter values to human-readable display labels
 * that match the Customer.io UI terminology.
 */

import { PlatformLabels } from './campaign-mapping/action-types';

/**
 * Newsletter channel labels
 * Maps backend channel values to user-friendly display names
 * Source: ~/code/ui/app/models/newsletter.ts Channel enum
 */
export const NewsletterChannelLabels: Record<string, string> = {
  email: 'Email',
  push: 'Push notification',
  twilio: 'SMS',
  webhook: 'Webhook',
  in_app: 'In-app message',
  unset: 'Not set',
};

/**
 * Newsletter test metric labels
 * Maps backend test_metric values to user-friendly display names
 * Source: ~/code/ui/app/models/newsletter.ts VALID_TEST_METRICS_MAP
 */
export const NewsletterTestMetricLabels: Record<string, string> = {
  clicked: 'Click rate',
  opened: 'Open rate',
  converted: 'Conversion rate',
};

// Re-export PlatformLabels for convenience (used by both actions and newsletters)
export { PlatformLabels };
